"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineProductSpecSheet;
function AlpineProductSpecSheet() {
    return Alpine.data('productSpecSheet', function () { return ({
        API_URL: '',
        loading: true,
        initialized: false,
        open: false,
        productId: 0,
        productTerm: 0,
        seriesName: '',
        skuName: '',
        attributes: [],
        productAttributeMeta: [],
        product: null,
        getSpecSheet: function (id, term, seriesName, skuName) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.API_URL = '/graphql';
                            this.loading = true;
                            this.initialized = true;
                            this.open = true;
                            this.attributes = [];
                            this.productAttributeMeta = [];
                            this.product = null;
                            this.productId = parseInt(id, 10);
                            this.productTerm = parseInt(term, 10);
                            this.seriesName = seriesName;
                            this.skuName = skuName;
                            return [4 /*yield*/, this.getProductAttributes()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.getProductWithAttributes()];
                        case 2:
                            _a.sent();
                            this.$nextTick(function () {
                                _this.loading = false;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        getProductAttributes: function () {
            return __awaiter(this, void 0, void 0, function () {
                var productAttributesResponse;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('getProductAttributes');
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryProductAttributes)];
                        case 1:
                            productAttributesResponse = (_a.sent());
                            return [2 /*return*/, new Promise(function (resolve) {
                                    if (productAttributesResponse.length < 1) {
                                        console.error('No attributes found');
                                    }
                                    _this.attributes = productAttributesResponse;
                                    var attributeQueryAsString = '';
                                    _this.attributes.forEach(function (attribute) {
                                        attributeQueryAsString = "".concat(attributeQueryAsString, ",product_attribute_").concat(attribute.slug.replaceAll('-', '_'));
                                    });
                                    var attributesAsArray = attributeQueryAsString.trim().split(',');
                                    var trimmedAttributesArray = (attributesAsArray.slice(1, attributesAsArray.length));
                                    _this.productAttributeMeta = trimmedAttributesArray;
                                    resolve();
                                })];
                    }
                });
            });
        },
        getProductWithAttributes: function () {
            return __awaiter(this, void 0, void 0, function () {
                var productAttributesMetaResponse;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('getProductWithAttributes');
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryStringForProducts)];
                        case 1:
                            productAttributesMetaResponse = (_a.sent());
                            return [2 /*return*/, new Promise(function (resolve) {
                                    _this.product = __assign({}, productAttributesMetaResponse[0]);
                                    resolve();
                                })];
                    }
                });
            });
        },
        /* eslint-disable */
        graphQLRequest: function (queryString) {
            return __awaiter(this, void 0, void 0, function () {
                var response, data;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, fetch(this.API_URL, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    query: queryString
                                }),
                            })];
                        case 1:
                            response = _d.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            data = _d.sent();
                            if (data.errors > 0) {
                                return [2 /*return*/];
                            }
                            if (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0
                                || ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.contentNodes) === null || _c === void 0 ? void 0 : _c.nodes.length) > 0) {
                                return [2 /*return*/, data.data.contentNodes.nodes];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        /* eslint-enable */
        get graphQLQueryStringForProducts() {
            return "query GetProductForSpecSheet {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT,\n            in: [".concat(this.productId, "]\n          }\n          first: 10\n        ) {\n          nodes {\n            databaseId\n            ... on GroupProduct {\n              name\n              teaser {\n                excerpt\n              }\n              link\n              featuredImage {\n                node {\n                  srcSet\n                }\n              }\n              metaData(keysIn: [").concat(this.productAttributeMeta.map(function (key) { return "\"".concat(key, "\""); }).join(','), "]) {\n                key\n                value\n              }\n            }\n          }\n        }\n      }");
        },
        get graphQLQueryProductAttributes() {
            return "query GetProductAttributesForSpecSheet {\n        contentNodes(\n          where: {\n            contentTypes: PRODUCT_ATTRIBUTE,\n            taxQuery: {\n              taxArray: {\n                field: ID,\n                taxonomy: TAX_PRODUCT_CATEGORY,\n                operator: IN,\n                terms: \"".concat(this.productTerm, "\"\n              }\n            }\n          }\n          first: 1000\n        ) {\n          nodes {\n            ... on Page_attribute {\n              title\n              slug\n              productAttributeFields {\n                hideFromProductComparisonTable\n                hideFromProductSearchFilter\n                label\n                outputStyle\n                prefix\n                suffix\n                type\n                comparisonType\n                options\n              }\n            }\n          }\n        }\n      }");
        },
    }); });
}
